/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 11/21/2017
 * Copyright All Rights Reserved
 */

import 'whatwg-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import store from 'store';
import Root from 'containers/RootContainer';
import 'src/scss/app.scss';
import config, { initializeConfigs, ENVIRONMENT, ROLLBAR_ACCESS_TOKEN, ROLLBAR_ENABLED } from 'support/config';
import rollbarInit from 'support/rollbarInit';

initializeConfigs().then(() => {
  rollbarInit(config(ROLLBAR_ENABLED), config(ENVIRONMENT), config(ROLLBAR_ACCESS_TOKEN));

  const render = (Component) => {
    ReactDOM.render(
      <Component store={store} />,
      document.getElementById('root')
    );
  };

  render(Root);

// If hot module replacement is enabled in development
  if (module.hot) {
    // When an update to the app is available
    module.hot.accept('containers/RootContainer', () => {
      // Render the updated app
      render(Root);
    });
  }
});
